import React from "react";
import VerifymappingContainer from "../../../containers/Payroll/VerifymappingContainer";

const Verifymapping = (props) => {
  return <VerifymappingContainer {...props} />;
};

export default Verifymapping;
